/**
 * 账号管理页面表格组件
 */

<template>
    <div id="amgnTable">
        <Spin fix v-if="ifSpin"></Spin>
        <div id="search">
            <label>分子公司：</label>
            <Select v-model="search.district" style="width:150px" placeholder="选择地区" :clearable="true">
                <Option v-for="item in districts" :value="item.name" :key="item.id"></Option>
            </Select>
            <label style="margin-left:15px">应用业务平台/系统名称：</label>
            <Input placeholder="输入应用业务平台/系统名称" v-model="search.platform" style="width:200px"></Input>
            <Button type="primary" icon="search" style="margin-left:10px" @click="searchData">搜索</Button> 
            <Button @click='addAccount' type="primary" icon="plus" style="margin-left:10px">添加</Button>
            <Button type="success" icon="ios-cloud-download" style="margin-left:10px" @click="exportData" v-if="ifExport">导出</Button>
        </div> 
        <p style="color:red">*当账号未设定权限时，所在分子公司人员可修改。设定分子公司权限，由分子公司负责人或质控中心管控修改。设定总部权限，由质控中心管控修改。</p>
        <Table :columns="columns1" :data="data1" stripe ref="table"></Table>
        <add-account :addModal="editAccount" :newAccount="newAccount" @close="closeModal" @reflash="reflash" mode="2">编辑账号</add-account>
        <Page :total="pageTotal" :current="currentPage" show-elevator style="margin-top:20px" @on-change="changePage"></Page>
        <Modal v-model="editPermission" @on-ok="editPermissionOK">
            <p slot="header">修改权限</p>
            <!-- {{newAccount.permission}}-{{newAccount.status}} -->
            <Form label-position="right" :label-width="100">
                <FormItem label="权限" required>
                    <Select v-model="newAccount.permission" style="width:300px">
                        <Option value="总部">总部</Option>
                        <Option value="子分公司">子分公司</Option>
                    </Select>
                </FormItem>
                <FormItem label="状态" required>
                    <Select v-model="newAccount.status" style="width:300px">
                        <Option value="注销">注销</Option>
                        <Option value="失效">失效</Option>
                        <Option value="有效">有效</Option>
                    </Select>
                </FormItem>
            </Form>
        </Modal>
    </div>
</template>

<script>
import expandRow from './table-expand.vue'
import addAccount from './addAccount.vue'
import ajax from '@/lib/ajax'
import axios from 'axios'
export default {
    components:{ expandRow , addAccount },
    data(){
        return{
            pageTotal:0,
            currentPage:1,
            index:0,
            editAccount:false,
            editPermission:false,
            // ifPermission:true,
            // ifEdit:true,
            ifSpin:false,
            // accountPermission:{
            //     permission:'',
            //     status:''
            // },
            districts:[],
            search:{
                district:'',
                platform:''
            },
            newAccount:{
                // ifContactPerson:"是",
                // ifContact:"是",
                // ifKeyPerson:"是",
                district:'',
                // areaname:[],
                province:'',
                city:'',
                platform:'',
                src:'',
                contactPerson:'',
                contact:'',
                use:[],
                account:'',
                pwd:'',
                date:'',
                key:'',
                keyPerson:'',
                keyUse:'',
                term:'',
                // permission:'',
                // status:'',
                explain:''
            },
            data1:[],
            columns1:[
                {
                    type: 'expand',
                    width: 50,
                    render: (h, params) => {
                        return h(expandRow, {
                            props: {
                                row: params.row
                            }
                        })
                    }
                },
                {
                    title:'省',
                    width:100,
                    render:(h,params)=>{
                        return h('span',this.data1[params.index].province)
                    }
                },{
                    title:'市',
                    width:100,
                    render:(h,params)=>{
                        return h('span',this.data1[params.index].city)
                    }
                },
                {
                    title:'所属子(分)公司',
                    key:'district',
                },
                // {
                //     title:'系统登记的联系人',
                //     key:'contactPerson',
                //     width:140
                // },{
                //     title:'系统联系人电话',
                //     key:'contact',
                //     width:140
                // },
                {
                    title:'应用业务平台/系统名称',
                    key:'platform',
                },{
                    title:'应用平台/系统链接地址',
                    key:'src',
                    render:(h,params)=>{
                        return h('a',{
                            domProps:{
                                href:this.data1[params.index].src,
                                target:"_blank"
                            }
                        },this.data1[params.index].src)
                    }
                },{
                    title:'用途',
                    key:'use',
                    render:(h,params)=>{
                        return h('span',{
                            domProps:{
                                innerText:this.data1[params.index].use.toString()
                            }
                        })
                    }
                },
                {
                    title:'状态',
                    render:(h,params)=>{
                        return h('span',this.data1[params.index].status?this.data1[params.index].status:"未设定")
                    },
                    width:80
                },
                {
                    title:'权限',
                    render:(h,params)=>{
                        return h('span',this.data1[params.index].permission?this.data1[params.index].permission:"未设定")
                    },
                    width:100
                },
                {
                    title:'操作',
                    key:'action',
                    align:'center',
                    width:200,
                    render:(h,params)=>{
                        return h('div',[
                             h('Button',{
                                props:{
                                    type:'primary',
                                    size:'small',
                                    disabled:(()=>{
                                        let enable=true;
                                        if(this.data1[params.index].permission){
                                            enable=this.data1[params.index].permission==='总部'?(!(this.$store.getters["session/hasRoles"]("质控人员")||this.$store.getters["session/hasRoles"]("Admin"))):this.ifEdit
                                        }else{
                                            enable=false;
                                        }
                                        return enable;
                                    })()
                                },
                                style:{
                                    marginRight:'5px'
                                },
                                on:{
                                    click:()=>{
                                        this.newAccount=JSON.parse(JSON.stringify(this.data1[params.index]));
                                        this.editAccount=true;
                                    }
                                }
                            },'修改信息'),
                            h('Button',{
                                props:{
                                    type:'warning',
                                    size:'small',
                                    disabled:this.ifPermission
                                },
                                on:{
                                    click:()=>{
                                        this.newAccount=JSON.parse(JSON.stringify(this.data1[params.index]));
                                        this.editPermission=true;
                                    }
                                }
                            },'权限管理')
                        ])
                    }
                }
            ]
        }
    },
    methods:{
        closeModal(){
            this.editAccount=false;
        },
        reflash(){
            this.getData(this.currentPage)
        },
        async getData(page=1,search={}){
            this.ifSpin=true;
            this.currentPage=page;
            let data = {
                "docu_type":"account",
                "page_num":page,
                "userid":this.$store.state.session.user.id.toString()
            }
            if(search.district){
                data["district"]=search.district;
            }
            if(search.platform){
                data["platform"]=search.platform;
            }
            let rep = await ajax.post("http://qy.chinapsp.cn:48884/Doc/all_root",data)
            if(rep.data.success){
                if(rep.data.result.length){
                    this.pageTotal=rep.data.max_page*10;
                    this.data1=[];
                    const resData = JSON.parse(rep.data.result);
                    resData.forEach((item)=>{
                        let obj = JSON.parse(item);
                        obj.use=obj.use.split(",");
                        this.data1.push(obj);
                    })
                    // this.data1=this.data1.reverse()
                    this.ifSpin=false;
                }else{
                    this.data1=[];
                    this.ifSpin=false;
                }
            }
        },
        changePage(page){
            this.getData(page,this.search);
        },
        async editPermissionOK(){
            let rep = await ajax.post('http://qy.chinapsp.cn:48884/Doc/update',{
                "docu_id":this.newAccount._id.$oid,
                "status":this.newAccount.status,
                "permission":this.newAccount.permission
            })
            if(rep.data.success){
                this.getData();
                this.editPermission=false;
            }
        },
        async getDistricts(){
            let rep = await ajax.get("/api/services/app/CLDistrict/GetList");
            if(rep.data.success){
                this.districts=rep.data.result.items;
            }
        },
        exportData(){
            axios({
                method: 'post',
                url: 'http://qy.chinapsp.cn:48884/Doc/download_excel',
                data: {
                    docu_type: 'account',
                    userid: this.$store.state.session.user.id.toString()
                },
                responseType: 'blob'
            }).then(response => {
                this.download(response.data)
            })
        },
        download (data) {
            if (!data) {
                return
            }
            let url = window.URL.createObjectURL(new Blob([data]))
            let link = document.createElement('a')
            link.style.display = 'none'
            link.href = url
            link.setAttribute('download', 'excel.xls')
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link); //下载完成移除元素
            window.URL.revokeObjectURL(url); //释放掉blob对象
        },
        addAccount(){
            this.$emit('addAccount');
        },
        searchData(){
            this.getData(1,this.search)
        }
    },
    created(){
        this.getData();
        this.getDistricts();
    },
    computed:{
        ifEdit:function(){
            if(this.$store.getters["session/hasRoles"]("分公司负责人")){
                return false;
            }
            if(this.$store.getters["session/hasRoles"]("质控（账号管理）")){
                return false;
            }
            if(this.$store.getters["session/hasRoles"]("Admin")){
                return false;
            }
            return true;
        },
        ifPermission:function(){
            if(this.$store.getters["session/hasRoles"]("质控（账号管理）")){
                return false;
            }
            if(this.$store.getters["session/hasRoles"]("Admin")){
                return false;
            }
            return true;
        },
        ifExport:function(){
            if(this.$store.getters["session/hasRoles"]("质控（账号管理）")){
                return true;
            }
            return false
        }
    }
}
</script>

<style lang="less">

</style>



